export function encodeMultipleFilters(filter: string[] | undefined) {
  if (!filter) return undefined;
  if (filter.length === 0) return undefined;
  return filter.join(",");
}
